import { FormField, LoadingBubbles } from '@domain-group/suit-theme'

import type { ProviderPriceListProductUnlockModel } from '@models/types'

import ProviderPriceListProductUnlock from './components/ProviderPriceListProductUnlock'

interface PublicationLiftoverSelectorProps {
  callbacks: {
    selectLiftover: (providerPriceListProductUnlock: ProviderPriceListProductUnlockModel) => void,
  },
  loading: boolean,
  providerPriceListProductUnlocks: ProviderPriceListProductUnlockModel[],
  selectedLiftoverIds: number[],
}

const PublicationLiftoverSelector = (props: PublicationLiftoverSelectorProps) => {
  const {
    callbacks: {
      selectLiftover,
    },
    loading = false,
    providerPriceListProductUnlocks,
    selectedLiftoverIds,
  } = props

  return (
    <FormField
      label="Select Liftovers"
      labelProps={{ flexShrink: 0, width: 'auto' }}
      labelRight={loading && (
        <LoadingBubbles color="blue" style={{ marginLeft: 'auto', width: 'auto' }} />
      )}
      marginTop="medium"
    >
      {providerPriceListProductUnlocks.map((providerPriceListProductUnlock) => {
        const selected = selectedLiftoverIds.includes(providerPriceListProductUnlock.id)

        return (
          <ProviderPriceListProductUnlock
            callbacks={{
              selectLiftover: () => selectLiftover(providerPriceListProductUnlock),
            }}
            key={providerPriceListProductUnlock.id}
            providerPriceListProductUnlock={providerPriceListProductUnlock}
            selected={selected}
          />
        )
      })}
    </FormField>
  )
}

export default PublicationLiftoverSelector
